import { createSelector } from 'reselect';

import { getMediaByIds } from 'modules/medias/selectors';
import { getRoot } from 'utils/selectors';

import { getUIState } from './general';

const getState = createSelector(
  getUIState,
  /** @returns {import("../reducer/ui/mediasLists").ConversationMediaListReducer} */
  state => state.mediasLists
);

const getMediaIds = createSelector(getState, state => state.ids);

export const getMediaPage = createSelector(getState, state => state.page);

export const hasMoreMedia = createSelector(getState, state => state.hasMore);

export const getMediaList = createSelector(getRoot, getMediaIds, getMediaByIds);

export const isMediaListLoading = createSelector(getState, state => state.loading);

export const getMediaListFilters = createSelector(getState, state => state.filters);
